import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import contentService from '../services/contentService';
import './DesarrollaModal.css';

const DesarrollaModal = ({ desarrolla, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    color: '#6b7280',  // ✅ AGREGAR COLOR
    profile_image_url: '',  // ✅ URL de la imagen
    is_active: true
  });

  const [profileImage, setProfileImage] = useState(null);  // ✅ Archivo de imagen
  const [profileImagePreview, setProfileImagePreview] = useState('');  // ✅ Preview URL
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const desarrollaTypes = [
    { value: 'interno', label: 'Interno', icon: '🏢', description: 'Desarrollo interno del equipo' },
    { value: 'externo', label: 'Externo', icon: '🌐', description: 'Desarrollo por terceros externos' },
    { value: 'agencia', label: 'Agencia', icon: '🎯', description: 'Desarrollo por agencia contratada' },
    { value: 'freelance', label: 'Freelance', icon: '👨‍💻', description: 'Desarrollo por freelancer' },
    { value: 'influencer', label: 'Influencer', icon: '⭐', description: 'Desarrollo por el influencer' }
  ];

  useEffect(() => {
    if (desarrolla) {
      setFormData({
        name: desarrolla.name || '',
        description: desarrolla.description || '',
        color: desarrolla.color || '#6b7280',  // ✅ AGREGAR COLOR
        profile_image_url: desarrolla.profile_image_url || '',  // ✅ AGREGAR URL DE IMAGEN
        is_active: desarrolla.is_active !== undefined ? desarrolla.is_active : true
      });
      // Cargar preview de imagen existente
      if (desarrolla.profile_image_url) {
        setProfileImagePreview(desarrolla.profile_image_url);
      }
    }
  }, [desarrolla]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = 'El tipo de desarrollo es requerido';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      let profileImageUrl = formData.profile_image_url || '';

      // Si hay una imagen nueva, subirla primero
      if (profileImage) {
        const uploadResponse = await contentService.uploadDesarrollaProfileImage(profileImage);
        profileImageUrl = uploadResponse.data.url;
        console.log('✅ Imagen subida:', profileImageUrl);
      }

      // Preparar datos para enviar
      const data = {
        name: formData.name,
        description: formData.description,
        color: formData.color,
        profile_image_url: profileImageUrl,
        is_active: formData.is_active
      };

      if (desarrolla) {
        // Editar
        await contentService.updateDesarrolla(desarrolla.id, data);
        alert('✅ Desarrolla actualizado exitosamente');
      } else {
        // Crear
        await contentService.createDesarrolla(data);
        alert('✅ Desarrolla creado exitosamente');
      }
      onClose();
    } catch (error) {
      console.error('Error saving desarrolla:', error);
      const errorMessage = error.response?.data?.detail
        || error.response?.data?.message
        || 'Error al guardar el tipo de desarrollo';
      alert(`❌ ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Limpiar error del campo
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validar que sea una imagen
      if (!file.type.startsWith('image/')) {
        alert('⚠️ Por favor selecciona un archivo de imagen válido');
        return;
      }

      setProfileImage(file);

      // Crear preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const getTypeInfo = (typeName) => {
    return desarrollaTypes.find(t => t.value === typeName) || {};
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={`${desarrolla ? 'Editar' : 'Crear'} Tipo de Desarrollo`}
      subtitle={desarrolla ? 'Modifica los datos del tipo' : 'Completa la información requerida'}
      icon="🔧"
      size="l"
      minimal
      footer={
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            className="estado-btn"
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="submit"
            form="desarrolla-form"
            className="estado-btn"
            disabled={loading}
          >
            {loading ? 'Guardando...' : (desarrolla ? 'Actualizar' : 'Crear')} Desarrolla
          </button>
        </div>
      }
    >
      <form id="desarrolla-form" onSubmit={handleSubmit}>
            {/* Tipo de Desarrollo */}
            <div className="form-group">
              <label className="form-label">
                Tipo de Desarrollo <span className="required">*</span>
              </label>
              <div className="type-options-grid">
                {desarrollaTypes.map((type) => (
                  <label
                    key={type.value}
                    className={`type-option ${formData.name === type.value ? 'selected' : ''}`}
                  >
                    <input
                      type="radio"
                      name="name"
                      value={type.value}
                      checked={formData.name === type.value}
                      onChange={handleChange}
                      className="type-radio"
                    />
                    <div className="type-option-content">
                      <span className="type-icon">{type.icon}</span>
                      <span className="type-label">{type.label}</span>
                      <span className="type-desc">{type.description}</span>
                    </div>
                  </label>
                ))}
              </div>
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>

            {/* Descripción */}
            <div className="form-group">
              <label className="form-label">
                Descripción
                <span className="optional-badge">Opcional</span>
              </label>
              <textarea
                name="description"
                rows={4}
                value={formData.description}
                onChange={handleChange}
                placeholder="Agrega detalles adicionales sobre este tipo de desarrollo..."
                className="form-textarea"
              />
              <span className="helper-text">
                Describe características específicas o información relevante
              </span>
            </div>

            {/* ✅ NUEVO: Selector de Color */}
            <div className="form-group">
              <label className="form-label">
                Color
                <span className="optional-badge">Opcional</span>
              </label>
              <div className="color-picker-wrapper">
                <input
                  type="color"
                  name="color"
                  value={formData.color}
                  onChange={handleChange}
                  className="color-input"
                />
                <input
                  type="text"
                  name="color"
                  value={formData.color}
                  onChange={handleChange}
                  placeholder="#6b7280"
                  className="color-text-input"
                  pattern="^#[0-9A-Fa-f]{6}$"
                  maxLength="7"
                />
                <div
                  className="color-preview-box"
                  style={{ backgroundColor: formData.color }}
                ></div>
              </div>
              <span className="helper-text">
                Elige el color que representará este tipo en la interfaz
              </span>
            </div>

            {/* ✅ NUEVO: Imagen de Perfil */}
            <div className="form-group">
              <label className="form-label">
                Imagen de Perfil
                <span className="optional-badge">Opcional</span>
              </label>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem'
              }}>
                <input
                  type="file"
                  id="profile-image-upload"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                />
                <label
                  htmlFor="profile-image-upload"
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
                    border: '2px dashed rgba(0, 0, 0, 0.2)',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    textAlign: 'center',
                    transition: 'all 0.2s',
                    fontWeight: '500',
                    color: '#374151'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = formData.color;
                    e.currentTarget.style.background = `linear-gradient(135deg, ${formData.color}10 0%, ${formData.color}20 100%)`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.2)';
                    e.currentTarget.style.background = 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)';
                  }}
                >
                  📷 {profileImage ? 'Cambiar imagen' : 'Seleccionar imagen'}
                </label>
                {profileImagePreview && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    padding: '1rem',
                    background: '#f9fafb',
                    borderRadius: '12px'
                  }}>
                    <img
                      src={profileImagePreview}
                      alt="Preview"
                      style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: '3px solid ' + formData.color,
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                      }}
                    />
                    <div style={{ flex: 1 }}>
                      <p style={{
                        margin: 0,
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        color: '#374151'
                      }}>
                        {profileImage ? profileImage.name : 'Imagen actual'}
                      </p>
                      {profileImage && (
                        <p style={{
                          margin: '0.25rem 0 0 0',
                          fontSize: '0.75rem',
                          color: '#6b7280'
                        }}>
                          {(profileImage.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setProfileImage(null);
                        setProfileImagePreview('');
                      }}
                      style={{
                        padding: '0.5rem 1rem',
                        background: '#fee2e2',
                        color: '#dc2626',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '500',
                        fontSize: '0.875rem'
                      }}
                    >
                      Eliminar
                    </button>
                  </div>
                )}
              </div>
              <span className="helper-text">
                Sube una imagen de perfil del desarrollador (máximo 5MB)
              </span>
            </div>

            {/* Estado Activo */}
            <div className="form-group">
              <div className="checkbox-wrapper">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="is_active"
                    checked={formData.is_active}
                    onChange={handleChange}
                    className="form-checkbox"
                  />
                  <span className="checkbox-text">
                    <span className="checkbox-title">Tipo Activo</span>
                    <span className="checkbox-description">
                      Este tipo estará disponible para asignar a posts
                    </span>
                  </span>
                </label>
              </div>
            </div>

            {/* Preview Card */}
            {formData.name && (
              <div className="preview-section">
                <h3 className="preview-title">Vista Previa</h3>
                <div className="preview-card" style={{ borderTopColor: formData.color, borderTopWidth: '4px', borderTopStyle: 'solid' }}>
                  <div className="preview-header">
                    <div className="preview-icon" style={{ background: `${formData.color}20` }}>
                      {profileImagePreview ? (
                        <img
                          src={profileImagePreview}
                          alt={getTypeInfo(formData.name).label}
                          style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            objectFit: 'cover'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                      ) : null}
                      <span style={{ color: formData.color, display: profileImagePreview ? 'none' : 'block' }}>
                        {getTypeInfo(formData.name).icon}
                      </span>
                    </div>
                    <div className="preview-info">
                      <h4>{getTypeInfo(formData.name).label}</h4>
                      <span className={`status-badge ${formData.is_active ? 'active' : 'inactive'}`}>
                        {formData.is_active ? '✓ Activo' : '✗ Inactivo'}
                      </span>
                    </div>
                  </div>
                  <div className="preview-description">
                    {formData.description || 'Sin descripción'}
                  </div>
                </div>
              </div>
            )}
      </form>
    </Modal>
  );
};

export default DesarrollaModal;